const SIU_URL = "https://siuprize.org";

export const getNavItems = (t) => {
  return [
    {
      title: t("str_home"),
      link_vi: SIU_URL,
      link_en: `${SIU_URL}/en/home/`,
    },
    {
      title: t("str_about_us"),
      children: [
        {
          title: t("str_founders"),
          link_vi: `${SIU_URL}/nha-sang-lap/`,
          link_en: `${SIU_URL}/en/founder/`,
        },
        {
          title: t("str_about_siu_prize"),
          link_vi: `${SIU_URL}/tong-quan-ve-cuoc-thi/`,
          link_en: `${SIU_URL}/en/about-siu-prize/`,
        },
        {
          title: t("str_siu_prize_medals"),
          link_vi: `${SIU_URL}/huy-chuong/`,
          link_en: `${SIU_URL}/en/huy-chuong/`,
        },
      ],
    },
    {
      title: t("str_nominations"),
      children: [
        {
          title: t("str_nomination_and_award_procedures"),
          link_vi: `${SIU_URL}/quy-trinh-de-cu-va-xet-giai/`,
          link_en: `${SIU_URL}/en/nomination-and-selection-process/`,
        },
        {
          title: t("str_list_of_organizations_making_nominations"),
          link_vi: `${SIU_URL}/danh-sach-truong-de-cu/`,
          link_en: `${SIU_URL}/en/list-of-nominated-schools/`,
        },
        {
          title: t("str_list_of_individuals_making_nominations"),
          link_vi: `${SIU_URL}/danh-sach-giao-su-de-cu/`,
          link_en: `${SIU_URL}/en/list-of-nominated-professors/`,
        },
      ],
    },
    {
      title: t("str_nomination_guide"),
      children: [
        {
          title: t("str_guidelines_for_nominations"),
          link_vi: `${SIU_URL}/huong-dan-cho-to-chuc/`,
          link_en: `${SIU_URL}/en/huong-dan-cho-to-chuc/`,
        },
        {
          title: t("str_personal_guide_gs"),
          link_vi: `${SIU_URL}/huong-dan-cho-ca-nhan-gs/`,
          link_en: `${SIU_URL}/en/huong-dan-cho-ca-nhan-gs/`,
        },
        {
          title: t("str_instructions_for_candidates"),
          link_vi: `${SIU_URL}/huong-dan-cho-ung-vien/`,
          link_en: `${SIU_URL}/en/huong-dan-cho-ung-vien/`,
        },
      ],
    },
    {
      title: t("str_fields_of_award"),
      children: [
        {
          title: t("str_prize_value"),
          link_vi: `${SIU_URL}/tong-quan-ve-giai-thuong/`,
          link_en: `${SIU_URL}/en/prize-overview/`,
        },
        {
          title: t("str_heath_sciences"),
          link_vi: `${SIU_URL}/khoa-hoc-suc-khoe/`,
          link_en: `${SIU_URL}/en/health-science/`,
        },
        {
          title: t("str_computer_science"),
          link_vi: `${SIU_URL}/khoa-hoc-may-tinh/`,
          link_en: `${SIU_URL}/en/computer-science/`,
        },
      ],
    },
    {
      title: t("str_contact"),
      link_vi: `${SIU_URL}/lien-he-voi-chung-toi/`,
      link_en: `${SIU_URL}/en/contact/`,
    },
  ];
};
